<template>
  <button
    type="button"
    :class="classList"
    @click="defaultClick"
    :disabled="disabled"
    :aria-expanded="collapsed ? String(!!nativeModel) : null"
    :aria-pressed="toggle && !collapsed ? String(!!nativeModel) : null"
  >
    <span v-if="iconOnly" class="d-flex align-items-center justify-content-center w-100">
      <span v-if="computedIconLeft" class="icon">
        <font-awesome-icon :icon="[iconType, computedIconLeft]" />
      </span>
      <span v-if="iconContainerLeft" class="d-flex align-items-center">
        <slot name="iconContainerLeft" />
      </span>
      <span v-if="iconContainerRight" class="d-flex align-items-center">
        <slot name="iconContainerRight" />
      </span>
      <span v-if="iconRight" class="icon">
        <font-awesome-icon :icon="[iconType, iconRight]" />
      </span>
    </span>
    <span v-else class="d-flex align-items-center w-100 justify-content-between">
      <span class="d-flex align-items-center">
        <span v-if="computedIconLeft" class="icon mr-2">
          <font-awesome-icon :icon="[iconType, computedIconLeft]" />
        </span>
        <span v-if="iconContainerLeft" class="d-flex align-items-center mr-2">
          <slot name="iconContainerLeft" />
        </span>
      </span>
      <span class="flex-grow-1 text-center">
        <slot />
      </span>
      <span class="d-flex align-items-center">
        <span v-if="iconContainerRight" class="d-flex align-items-center ml-2">
          <slot name="iconContainerRight" />
        </span>
        <span v-if="iconRight" class="icon ml-2">
          <font-awesome-icon :icon="[iconType, iconRight]" />
        </span>
      </span>
    </span>
    <span v-if="$slots.srText && iconOnly" class="sr-only">
      <slot name="srText" />,
    </span>
  </button>
</template>
<script>
export default {
  event: ['click','update:modelValue'],
  model: { // vue 2 v-model
    event: 'update:modelValue',
    prop: 'modelValue',
  },
  props: {
    /** @type {()=>any} */
    action: {
      Type: Function,
      default: () => null,
    },
    icon: String, // Property
    iconLeft: String, // New property for left icon
    iconRight: String, // New property for right icon
    iconOnly: Boolean, // Switch
    unstyled: Boolean, // Class Switch (unsupported since this component just Explodes a simple Button, Use Unstyled Button)
    disabled: Boolean, // Switch
    presetSize: Boolean, // Switch => disables w-100
    toggle: Boolean, // Switch => if true, stores the modelValue and updates it
    collapsed: Boolean, // Mode, not A value!
    secondary: Boolean, // Class Switch
    danger: Boolean, // Class Switch (e.g. cancel/destructive actions)
    lg: Boolean, // Class Switch
    modelValue: {
      Type: Object,
      default: null,
    },
    iconType: {
      type: String,
      default: 'fas',
    },
  },
  computed: {
    nativeModel: {
      get() {return this.modelValue;},
      set(value) {this.$emit('update:modelValue', value);}
    },
    computedIconLeft() {
      return this.iconLeft || this.icon;
    },
    iconContainerLeft() {
      return !!this.$slots.iconContainerLeft;
    },
    iconContainerRight() {
      return !!this.$slots.iconContainerRight;
    },
    iconContainer() {
      return this.icon && !this.iconOnly;
    },
    classList() {
      let _default = 'def-button a11y-button';
      if (this.presetSize) {
        _default = _default.concat(' is-preset-size m-auto noPadding');
      } else {
        _default = _default.concat(' is-fluid w-100 mx-0');
      }
      if (this.danger) {
        _default = _default.concat(' is-danger');
      } else if (this.secondary) {
        _default = _default.concat(' is-secondary');
      }
      if (this.iconOnly && this.presetSize) {
        _default = _default.replace(' m-auto','');
      }
      if (this.lg) {
        _default = _default.concat(' is-lg');
      }
      if (this.iconContainer) {
        return _default.concat(' d-flex flex-row');
      }
      return _default;
    },
  },
  methods:{
    defaultClick(event) {
      if (this.action === null){
        this.$emit('click', event);
      } else this.action(event);
      if (this.toggle) { // change the collapsed state
        this.nativeModel = !this.nativeModel;
      }
    },
  },
}
</script>
<style scoped>
.icon {
  align-self: center;
}


</style>
